// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"UserMenuItem-module_menuItem_oPyVt","promotional":"UserMenuItem-module_promotional_1Te-J"};